import React from 'react';
import { FedopsLoggerStore } from '../../stores/FedopsLoggerStore';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { UiLoggerStore } from '../../stores/UiLoggerStore';
import { injectV2 } from '../../injectV2';
import { TemplatesGrid } from './TemplatesGrid/TemplatesGrid';

interface TemplatesProps {
  fedopsLoggerStore: FedopsLoggerStore;
  templatesStore: TemplatesStore;
  uiLoggerStore: UiLoggerStore;
  dataHook?: string;
}

const TemplatesCmp: React.FC<TemplatesProps> = ({ templatesStore, dataHook, uiLoggerStore, fedopsLoggerStore }) => {
  const { itemsPerPage, itemsPerPageUUID } = templatesStore;
  const widgetType = templatesStore.getWidgetType(templatesStore.loadedFetchParams);
  const categorySlug =
    templatesStore.loadedFetchParams?.type === 'search' ? 'search' : templatesStore.loadedFetchParams?.categorySlug;
  const subCategorySlug = templatesStore.loadedFetchParams?.subCategorySlug;

  React.useEffect(() => {
    fedopsLoggerStore.stopActiveInteraction();
    uiLoggerStore.logPageFullyRendered(uiLoggerStore.getLastInteractionKey());
    uiLoggerStore.logGenericPageView();
  }, [fedopsLoggerStore, itemsPerPageUUID, uiLoggerStore]);

  return (
    <TemplatesGrid
      dataHook={dataHook}
      itemsPerPage={Array.from(itemsPerPage.entries())}
      itemsPerPageUUID={itemsPerPageUUID}
      widgetType={widgetType}
      categorySlug={categorySlug}
      subCategorySlug={subCategorySlug}
    />
  );
};

export const Templates = injectV2('templatesStore', 'uiLoggerStore', 'fedopsLoggerStore')(TemplatesCmp);
